import React from 'react';
import VisitList from './visitlist';
import { createDescriptionString, getCurrentPort } from '../utilsVisits';
import { isHostSubDomain } from '../utils';

const BASE_URL = '/innflutningur/raunsiglingar/';

export default class VesselListItemSimple extends React.Component {
  constructor(props) {
    super(props);
    this.onClickItem = this.onClickItem.bind(this);
    this.onUpdateStatus = this.onUpdateStatus.bind(this);
    this.state = { showChildren: props.showChildren ? true : false, status: '' };
  }

  componentDidMount() {
    const currentPort = getCurrentPort(this.props.visits);
    const status = createDescriptionString(this.props.visits, currentPort);

    this.setState({ status });
  }

  onClickItem() {
    this.setState({ showChildren: !this.state.showChildren });
  }

  onUpdateStatus(status) {
    this.setState({ status });
  }

  renderCell(item, index) {
    const cssClasses = ['list__items__item__vessel__simple'];

    const url = `${BASE_URL}?voyage=${item}`;
    let link = null;
    if(window.location.host.match(new RegExp(/samskip/g)) && !isHostSubDomain(window.location.host)) {
      link = (
        <a href={url} className="list__items__item__vessel__simple__a">
          {item}
        </a>
      );
    }
    else {
      link = (
        <a href={`https://www.samskip.is/${url}`} target="_blank" rel="noopener noreferrer" className="list__items__item__vessel__simple__a">
          {item}
        </a>
      );
    }

    return (
      <span key={index} className={cssClasses.join(' ')} onClick={this.onClickItem}>
        {link}
      </span>
    );
  }

  renderItem() {
    const items = this.props.items;
    const headers = this.props.headers || this.props.items;

    return Object.keys(headers).map((key, index) => {
      const item = items[key];
      return this.renderCell(item, index);
    });
  }

  renderStatus() {
    return (
      <span className="list__items__item__vessel__simple status">
        <div className="inner">{this.state.status}</div>
      </span>
    );
  }

  render() {
    const Tag = this.props.tag;

    return (
      <Tag className={this.props.className}>
        {this.renderItem()}
        {this.renderStatus()}
      </Tag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/vesselListItemSimple.js